import RichTextDataDefinitionList from "../../bloks/richTextWidgets/richTextDataDefinition/richTextDataDefinitionList";
import RichTextSummaryDetail from "../../bloks/richTextWidgets/richTextSummaryDetail/richTextSummaryDetail";
import RichTextIndention from "../../bloks/richTextIndention/richTextIndention";
import { MARK_LINK, MARK_STYLED, NODE_IMAGE, render } from "storyblok-rich-text-react-renderer"
import RichTextAnchor from "../../bloks/richTextWidgets/richTextAnchor/richTextAnchor";
import StoryblokLink from "../link/StoryblokLink"
import { richTextLinkToLinkObject } from "../link/helpers";
import { useCompressedImage } from "../storyblokImageBasic/helpers";

const renderStyledSpan = (children, props = {}) => <span className={props.class}>{children}</span>;

// Add any components that need to be renderable in rich text to the "blokResolvers" object
// https://github.com/claus/storyblok-rich-text-react-renderer
function RichTextWithBlokRenderer({ document }) {
  return render(document, {
    blokResolvers: {
      ["richtextindention"]: (blok) => {
        return <RichTextIndention blok={blok} />;
      },
      ["anchor"]: (blok) => {
        return <RichTextAnchor blok={blok} />;
      },
      ["datadefinitionlist"]: (blok) => {
        return <RichTextDataDefinitionList blok={blok} />;
      },
      ["summarydetail"]: (blok) => {
        return <RichTextSummaryDetail blok={blok} />;
      },
    },
    markResolvers: {
      [MARK_LINK]: (children, storyblokLinkObject) =>
        <StoryblokLink linkObject={richTextLinkToLinkObject(storyblokLinkObject)}>{children}</StoryblokLink>,
      [MARK_STYLED]: renderStyledSpan,
    },
    nodeResolvers: {
      [NODE_IMAGE]: (children, {alt, title, src}) => <img src={useCompressedImage(src)} alt={alt} title={title} />
    }
  });
}

export default RichTextWithBlokRenderer;
